import {ContactPage} from './Contact.jsx';
export default ContactPage;
